//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./call_utils.d.ts" />

import * as $ from "skir-client";

// -----------------------------------------------------------------------------
// struct Timestamp
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `Timestamp.Mutable`. */
export class Timestamp extends $._FrozenBase {}

function initTimestamp(target, initializer) {
  target.relativeSeconds = initializer.relativeSeconds ?? 0;
}

// -----------------------------------------------------------------------------
// enum Participant.Category
// -----------------------------------------------------------------------------

/**
 * Deeply immutable.
 *
 * @alias Participant.Category
 */
class Participant_Category extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct Participant
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `Participant.Mutable`. */
export class Participant extends $._FrozenBase {}

function initParticipant(target, initializer) {
  target.id = initializer.id ?? 0;
  target.name = initializer.name ?? "";
  target.isHost = initializer.isHost ?? false;
  target.platform = initializer.platform ?? "";
  target.email = initializer.email ?? null;
  target.category = initializer.category ? Participant_Category.create(initializer.category) : null;
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "call_utils.skir",
  [
    {
      kind: "struct",
      ctor: Timestamp,
      initFn: initTimestamp,
      name: "Timestamp",
      fields: [
        {
          name: "relative_seconds",
          property: "relativeSeconds",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "float32",
          },
        },
      ],
      removedNumbers: [
        1,
      ],
    },
    {
      kind: "enum",
      ctor: Participant_Category,
      name: "Category",
      parentCtor: Participant,
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "INTERNAL",
          number: 1,
        },
        {
          name: "EXTERNAL",
          number: 2,
        },
      ],
    },
    {
      kind: "struct",
      ctor: Participant,
      initFn: initParticipant,
      name: "Participant",
      fields: [
        {
          name: "id",
          property: "id",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "int32",
          },
        },
        {
          name: "name",
          property: "name",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "is_host",
          property: "isHost",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "platform",
          property: "platform",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "email",
          property: "email",
          number: 4,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "string",
            },
          },
        },
        {
          name: "category",
          property: "category",
          number: 5,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: Participant_Category,
            },
          },
        },
      ],
      removedNumbers: [
        6,
      ],
    },
  ]
);
